<template>
  <div>
    <ToolsPopup
      :isActive="isDetailsActive"
      :selectedTools="this.pageData"
      @close="toggleDetails"
    />
    <b-modal id="modal-1" title="Share" centered hide-footer>
      <div class="d-flex justify-content-around mb-8">
        <a
          rel="nofollow"
          :href="`https://facebook.com/share.php?u=${copy}`"
          target="_black"
        >
          <img
            class="w-10 h-10 cursor-pointer"
            src="../../../assets/icons/facebook.svg"
            alt=""
          />
        </a>
        <a
          :href="`https://linkedin.com/sharing/share-offsite/?url=${copy}`"
          target="_black"
        >
          <img
            class="w-10 h-10 cursor-pointer"
            src="../../../assets/icons/Linkedin.svg"
          />
        </a>
        <a :href="`mailto:?body=${copy}`" target="_black">
          <img
            class="w-10 h-10 cursor-pointer"
            src="../../../assets/icons/Mail.svg"
            alt=""
          />
        </a>
        <a :href="`https://api.whatsapp.com/send?text=${copy}`" target="_black">
          <img
            class="w-10 h-10 cursor-pointer"
            src="../../../assets/icons/Whatsapp.svg"
            alt=""
          />
        </a>
        <a
          :href="`https://twitter.com/share?text=google&url=${copy}`"
          target="_black"
        >
          <img
            class="w-10 h-10 cursor-pointer"
            src="../../../assets/icons/Twitter.svg"
            alt=""
          />
        </a>
      </div>

      <!-- <div class="container" ref="modalBody">
        <input type="text" v-model="message" />
        <button type="button" @click="doCopy(message)">Copy!</button>
      </div> -->
      <b-input-group size="md" class="mb-2">
        <b-form-input
          type="text"
          :class="{ inputstyle: applystyle }"
          v-model="copy"
        ></b-form-input>
        <b-input-group-prepend
          ref="modalBody"
          type="button"
          is-text
          class="cursor-pointer textstyle"
          @click="doCopy(copy)"
        >
          COPY
        </b-input-group-prepend>
      </b-input-group>
    </b-modal>

    <div class="bg-white relative md:pt-32 lg:pt-32 pt-24">
      <div class="md:px-12 lg:px-16 px-0 flex flex-wrap">
        <div class="w-full md:px-12 lg:px-16 px-4">
          <div class="w-full relative z-index1">
            <div class="cursor-pointer" @click="toggleDetails(true, item)">
              <img
                v-if="pageData.image"
                :src="$imageURL + '/' + pageData.image"
                alt="ToolsImage"
                class="w-full rounded-lg h510px-res object-contain"
                @error="hasError = true"
              />
              <img
                v-else
                :src="defaultImage"
                alt="ToolsImage"
                class="w-full rounded-lg h510px-res object-cover"
                @error="hasError = true"
              />
            </div>
          </div>
          <!-- contentLock: {{ contentLock }} -->
          <div class="md:mt-10 lg:mt-10 mt-6">
            <div class="flex items-center gap-1 justify-between">
              <p class="fsize32 sm-fsize20px font-bold text-black">
                {{ pageData.title }}
              </p>
              <div class="flex justify-center items-center gap-4">
                <img
                  v-b-modal.modal-1
                  @click="dialogVisible = true"
                  src="./../../../assets/images/share.png"
                  alt="ShareIcon"
                  class="lg:h-5 lg:w-5 md:h-6 md:w-6 w-4 h-4 cursor-pointer"
                />
                <b-button
                  type="Download"
                  variant="primary"
                  filled
                  class="md:px-10 lg:px- px-6 md:py-3 lg:py-3 py-1 fs16700"
                  @click="toggleDetails(true, item)"
                  >Download</b-button
                >
              </div>
            </div>
            <br />
            <p class="fsize20 sm-fsize20px">
              {{ pageData.description }}
            </p>
          </div>
          <div class="mt-4 flex items-center font-semibold text-black">
            <p>📖 Read Time: {{ pageData.readTime }} minutes</p>
            <p class="ml-6">💰 {{ pageData.paytype }}</p>
          </div>
        </div>
        <br />
        <div
          class="border my-6 rounded-lg p-3 lg:mb-12 md:mb-12 md:px-12 lg:px-16 px-4"
        >
          <h3 class="fsize22 font-semibold">Disclaimer:</h3>
          <p class="leading-tight fsize16 mt-3 clr-2e2e2e text-justify">
            The information provided on this website is for educational purposes
            only and is not intended to be a substitute for professional medical
            advice, diagnosis, or treatment.
          </p>
          <p class="fsize16 mt-2 clr-2e2e2e">
            Readers should seek professional medical advice and treatment for
            any specific health-related issues."
          </p>
          <p class="fsize16 mt-2 clr-2e2e2e">
            The information presented on this website is provided 'as is'
            without any representations or warranties, express or implied. The
            website owner and contributors disclaim all liability for any
            damages or losses arising from the use of this information.
          </p>
        </div>
      </div>
      <div class="bge3ceff-opa rounded-t-5555 mt-12">
        <DownloadApp />
        <Footer />
      </div>
    </div>
  </div>
</template>

<script>
import DownloadApp from "../../home/components/DownloadApp.vue";
import Footer from "../../Footer.vue";
import ToolsPopup from "./components/ToolsPopup.vue";
import { mapState } from "vuex";
import Swal from "sweetalert2";
import _ from "lodash";
export default {
  components: {
    ToolsPopup,
    DownloadApp,
    Footer,
  },

  data() {
    return {
      categoryId: null,
      isDetailsActive: false,
      search: "",
      contentLock: false,
      dialogVisible: false,
      applystyle: false,
      copy: `${process.env.VUE_APP_BASE_URL_CORE_API}cms/page/ToolGet/${this.$route.params.slug}`,
      editModal: false,
      relatedPages: [],
      hasError: false,
      pageData: {},
      selectedTools: {},
      //   blogId: "61adf7f010718313e80bcc4b",
      defaultImage:
        this.$imageURL + "/caregiversaathi/default/dummy%20image.jpg",
      defaultAuthor:
        this.$imageURL + "/caregiversaathi/default/dummy%20image.jpg",
    };
  },

  computed: {
    ...mapState("cms", {
      pageCategories: "pageCategories",
      filtertags: "filtertags",
      filters: "filters",
      pages: "pages",
      categorywisepages: "categorywisepages",
    }),
    ...mapState("auth", { user: "user" }),
    ...mapState("auth", { getUserByUserId: "getUserByUserId" }),
    relatedBlogData() {
      let relatedData = [];
      if (
        this.categorywisepages &&
        this.categorywisepages.data &&
        this.categorywisepages.data.length > 0
      ) {
        this.categorywisepages.data.forEach((tool) => {
          if (relatedData.length === 10) {
            return relatedData;
          }
          if (tool._id !== this.pageData._id) {
            relatedData.push(tool);
          }
        });
      }
      return relatedData;
    },
  },
  methods: {
    isContentlock() {
      if (this.page && this.page.onlyRegistered === true) {
        if (this.isNotLoggedIn()) {
          this.contentLock = true;
        } else {
          this.contentLock = false;
        }
      }

      if (
        this.page &&
        this.page.memberships &&
        this.page.memberships.length > 0
      ) {
        let result = this.page.memberships.some(
          (membership) =>
            membership._id === this.getUserByUserId.currentMembership
        );
        if (!result) {
          this.contentLock = true;
        } else {
          this.contentLock = false;
        }
      } else {
        this.contentLock = false;
      }
    },
    isObjEmpty(value) {
      if (Object.keys(value).length === 0 && value.constructor === Object) {
        return true;
      }
      return false;
    },
    async getPage() {
      const slug = this.$route.params.slug
        .replace(/-/g, " ")
        .replace(/_/g, "-");
      const data = await this.$store.dispatch("cms/getPage", slug);
      if (this.isObjEmpty(data.data)) {
        this.$swal.fire({
          text: "Tool is not Avaliable!",
          icon: "success",
          confirmButtonText: "Okay",
          confirmButtonColor: "#830c81",
          showCancelButton: false,
        });
        return this.$router.push({ name: "toolsandhandbook" });
      }
      this.pageData = data.data;
      this.selectedTools = this.pageData;
    },
    doCopy(copy) {
      this.$copyText(copy, this.$refs.modalBody);
      this.applystyle = true;
      // swal.fire({ title: "", icons: "success" });
      this.$swal.fire({
        text: "Link copied to clipboard",
        confirmButtonColor: "#830c81",
        showCancelButton: false,
        timer: 2000,
      });
    },
    destroyed() {
      clearInterval((this.applystyle = false));
    },

    isNotLoggedIn() {
      if (sessionStorage.getItem("token")) {
        return false;
      } else {
        return true;
      }
    },
    toggleDetails(val = false, item = {}) {
      try {
        // console.log(this.categorywisepages.data);
        let clickedBlogId = "";
        if (Object.keys(this.user).length !== 0) {
          this.categorywisepages.data.forEach((element) => {
            if (element._id === item._id) {
              if (
                element.memberships != null &&
                element.memberships.length !== 0
              ) {
                clickedBlogId = element.memberships[0]._id;
              }
            }
          });
        }
        if (item.onlyRegistered) {
          if (Object.keys(this.user).length === 0) {
            this.$router.push({ name: "signin" });
            Swal.fire({
              title: "Login",
              text: "To access the content, kindly proceed with registration/login",
              icon: "warning",
              confirmButtonColor: "#830c81",
              showConfirmButton: true,
            });
            return;
            //   .then((result) => {
            //   if (result.isConfirmed) {
            //     this.$router.push({ name: "signin" });
            //   }
            // });
          } else if (item.onlySubscribed) {
            if (
              this.user.membership != null &&
              this.user.membership.includes(clickedBlogId)
            ) {
              this.isDetailsActive = val;

              this.selectedTools = item;
            } else {
              Swal.fire({
                title: "Subscribe",
                text: "Please Subscribe to our membership to view the Self-Help Tool",
                icon: "warning",
                confirmButtonColor: "#830c81",
                confirmButtonText: "Show Plans",
                showConfirmButton: true,
                showCancelButton: true,
              }).then((e) => {
                if (e.isConfirmed) {
                  this.$router.push({
                    path: "/subscribe1",
                    // query: { buymembership: true },
                  });
                }
              });
            }
          } else {
            this.isDetailsActive = val;

            this.selectedTools = item;
          }
        } else {
          this.isDetailsActive = val;

          this.selectedTools = item;
        }
        // this.isDetailsActive = val;

        // this.selectedTools = item;
        // console.log(this.selectedTools);
      } catch (error) {
        console.log(error);
      }
    },

    async init() {
      if (this.categorywisepages.hasOwnProperty("data")) {
        // console.log("FOUND: " + this.categorywisepages);
        await this.getPage();
        this.isContentlock();
      } else {
        // console.log("NOT FOUND" + this.categorywisepages);
        await this.getPage();
        this.isContentlock();
      }
    },
    async getMemberAndUser() {
      try {
        if (this.user && this.user._id) {
          let getUserPayload = {
            userId: this.user._id, ///
          };
          const getUser = await this.$store.dispatch(
            "auth/getUserByUserId",
            getUserPayload
          );
          // console.log("GETUSER:", this.getUserByUserId);
        }
      } catch (error) {
        console.log(error);
      }
    },
  },
  mounted() {
    this.getMemberAndUser();
    this.init();
    // this.copy = `${process.env.VUE_APP_BASE_URL_CORE_API}cms/page/${this.$route.params.slug}`;
  },
  //   async mounted() {
  //     if (Object.keys(this.user).length !== 0) {
  //       let getUserPayload = {
  //         userId: this.user._id,
  //       };
  //       const getUser = await this.$store.dispatch(
  //         "auth/getUserByUserId",
  //         getUserPayload
  //       );
  //     }
  //     console.log("categorywisepages", this.categorywisepages);

  //     this.init();
  //   },
};
</script>
<style>
.input-group > .input-group-append > .btn,
.input-group > .input-group-append > .input-group-text,
.input-group > .input-group-prepend:not(:first-child) > .btn,
.input-group > .input-group-prepend:not(:first-child) > .input-group-text,
.input-group > .input-group-prepend:first-child > .btn:not(:first-child),
.input-group
  > .input-group-prepend:first-child
  > .input-group-text:not(:first-child) {
  background: #4f0a4b;
  color: white;
}
</style>
